import { useEffect, useMemo, useState } from "react";
import { useAccountJwtToken } from "../../../hooks/useAccountJwtToken.js";
import { trackAnalyticsEvent } from "../../../others/tracking.js";
/**
 * Use the `?magic-link-token=` parameter and create a new session (JWT).
 * It automatically returns the current JWT token if already one is set in current browser cache.
 */ function useAccountMagicLinkToken(receiveJwt, localStorageName) {
    const params = useMemo(()=>new URLSearchParams(window.location.search), []);
    const [magicLinkToken, setMagicLinkToken] = useState(params.get("magic-link-token") || undefined);
    const { jwt, saveJwt } = useAccountJwtToken(localStorageName);
    useEffect(()=>{
        if (magicLinkToken) {
            const post = async ()=>{
                saveJwt(undefined);
                const newUrl = window.location.href.replace(/([?]?magic-link-token=\w{8}-\w{4}-\w{4}-\w{4}-\w{12}[&]?)/gm, "");
                window.history.replaceState({}, document.title, newUrl);
                try {
                    saveJwt(await receiveJwt(magicLinkToken));
                    trackAnalyticsEvent("login", {
                        ga: {
                            event_category: "engagement",
                            event_label: "Customer center login"
                        },
                        matomo: {
                            category: "engagement",
                            name: "Customer center login"
                        }
                    });
                } finally{
                    setMagicLinkToken(undefined);
                }
            };
            post();
        }
    }, []);
    return {
        magicLinkToken,
        jwt: magicLinkToken ? undefined : jwt,
        saveJwt,
        // Wipe the cached JWT and the in-memory magic-link token so a fresh
        // sign-in can start, e.g. after a 401 from a JWT-restore attempt.
        erase: function() {
            saveJwt(undefined);
            setMagicLinkToken(undefined);
        }
    };
}
export { useAccountMagicLinkToken };
